import KyMethod from "./KyMethod"

interface RisebinarLinkBody {
  alias?: string
  type: "direct"
  password?: null
  active: true
  expires_at?: Date
  activates_at?: Date
  utm?: string
  domain_id?: null
  title?: string
  description?: string
  pixels?: any[]
  groups?: any[]
  rules?: any[]
  long_url: string
}

export default class RisebinarRepository extends KyMethod {
  async getRawRisebinarList(query: any) {
    return this._getPaginationData("/risebinars", query)
  }

  async getRawRisebinarDetail(slug: string | string[]) {
    return this._getPublicData(`/risebinars/${slug}`)
  }

  protected async getRawRisebinarLink(body: RisebinarLinkBody) {
    return this._protectedExternalCrudMethod("https://harisenin.link/api/v1/link", {
      body,
      method: "post",
      token: process.env.HARISENIN_LINK_TOKEN || process.env.LINK_TOKEN || "",
    })
  }

  async getRawRisebinarForm(slug: string) {
    return this._getProtectedData(`/risebinar/${slug}/form`, {
      version: "v3",
    })
  }
}
